const {
  companies = [],
  programmes: jobTypes = [],
  jobRoles = [],
  genders = [],
  regions = [],
  start_years: startYears = [],
  institution_start_years: institutionStartYears = [],
  salary_frequencies: salaryFrequencies = [],
  programme_lengths: jobLengths = [],
  training_providers: trainingProviders = [],
} = window.__RMP_REVIEW_ENTITIES__ || {};

export default {
  companies,
  jobTypes,
  jobRoles,
  genders,
  regions: regions.filter((region) => region.value !== 27), // RMA-3800
  startYears,
  institutionStartYears,
  salaryFrequencies,
  jobLengths,
  trainingProviders,
  emailFrequencies: [],
  ethnicities: [],
  parentProfessions: [],
  freeSchoolMeals: null,
  site: {
    cdnUrl: RMP_CDN_URL,
    shortName: 'RMA',
    fullName: 'RateMyApprenticeship',
    url: 'https://www.ratemyapprenticehsip.co.uk',
  },
  config: {
    cacheNamespace: 'entity',
  },
};
